import { setTokens } from "../utils/tokens";
import { publicApi } from "./api.service";

/**
 * Extract access token from URL query param (cross-app SSO from user-ui).
 * Immediately strips the token from the URL bar for security.
 */
export const loadTokenFromUrl = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  if (token) {
    params.delete('token');
    const cleaned = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}${window.location.hash}`;
    window.history.replaceState({}, '', cleaned);
  }
  return token || null;
};

export const loadAccessToken = () => {
  return publicApi.get<{
    accessToken: string;
    refreshToken: string;
  }>('/v0/auth/trade-refresh-token').then((res) => {
    const { accessToken, refreshToken } = res.data;
    // Do something with the access token
    // console.log({ accessToken, refreshToken });
    setTokens(accessToken, refreshToken, true);
  });
};